// import poster from "../assets/images/cinematic-3.png";

// export default [
//   {
//     id: "h-series-hero",
//     type: "video",
//     videoSrc: "/videos/landking-video.mp4",
//     poster,
//     fallbackImg: poster,
//     title: "Dare the Load. Lead the Road.",
//     subtitle: "LANDKING H-Series engineered for brutal terrains—built to outlast and outwork.",
//     ctaText: "Explore LandKing →",
//     ctaHref: "/vehicles"
//   }
// ];


// import poster from "../assets/images/cinematic-3.png";

// export default [
//   {
//     id: "h-series-hero",
//     type: "video",
//     videoSrc: "/videos/landking-video.mp4",
//     poster,
//     fallbackImg: poster,

//     // 👇 Use translation keys instead of raw text
//     titleKey: "homeBanner.homeBannerOne.bannerTitle",
//     subtitleKey: "homeBanner.homeBannerOne.bannerSubtitle",
//     ctaKey: "homeBanner.homeBannerOne.bannerCTA",

//     ctaHref: "/vehicles"
//   }
// ];


import poster from "../assets/images/cinematic-3.png";

export default [
  {
    id: "h-series-hero",
    type: "video",
    videoSrc: "/videos/landking-video.mp4",
    poster,
    fallbackImg: poster,

    // ✅ key prefix
    i18nKey: "homeBanner.homeBannerOne",

    ctaHref: "/vehicles"
  }
];
